import { OwnershipType } from './OwnershipType'
import { ShareHolder } from './ShareHolder'

export const GroupPieChart = () => {
  return (
    <div
      className="dFlex justifyContentCenter"
      style={{ gap: '180px', paddingTop: '8px' }}
    >
      <ShareHolder />
      <OwnershipType />
    </div>
  )
}
